import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "volume_0",
  "use": "volume_0-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"volume_0\"><path d=\"M30.72 12.587l-1.92-1.92-3.413 3.413-3.52-3.413-1.92 1.92L23.467 16l-3.413 3.413 1.92 1.92 3.413-3.413 3.413 3.413 1.92-1.92L27.2 16l3.52-3.413zM16.213 2.88l-7.467 7.68H3.413c-1.067 0-2.027.96-2.027 2.027v6.827c0 1.173.853 2.027 2.027 2.027h5.333l7.467 7.68c.427.427 1.173.107 1.173-.533V3.308c-.107-.533-.747-.853-1.173-.427z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol